export const MARKER_GROUP_TYPES = {
  station: 'station',
  roadsideService: 'roadsideService'
} as const;

export type MarkerGroupTypes = typeof MARKER_GROUP_TYPES;
export type MarkerGroupTypeKey = keyof MarkerGroupTypes;
export type MarkerGroupType = typeof MARKER_GROUP_TYPES[MarkerGroupTypeKey];